import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { environment } from 'src/environments/environment';
import { throwError, BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class HuddlesService {
  tabType = {
    SUMMARY: 'summary',
    ALL_HUDDLES: 'all-huddles',
    ALL_ACTION_PLANS: 'all-action-plans',
    ALL_SUGGESTIONS: 'all-suggestions',
    ALL_SPOTLIGHTS: 'all-spotlights'
  }

  private actionsSource = new BehaviorSubject<any>(null);
  private spotlightsSource = new BehaviorSubject<any>(null);
  private spotlightResponse = new BehaviorSubject<any>(null);
  private escalationsSource = new BehaviorSubject<any>(null);
  private selectedLevelSource = new BehaviorSubject<string | null>(null);
  private optionsSource = new BehaviorSubject<{ [key: string]: string } | null>(null);
  private isSidebarOpen = new BehaviorSubject<boolean>(false);
  private currentTabSubject = new BehaviorSubject<string>(this.tabType.SUMMARY);

  currentTab$ = this.currentTabSubject.asObservable();

  // Method to set the current tab
  setCurrentTab(tab: string) {
    this.currentTabSubject.next(tab);
  }

  // Method to get the current tab value (optional)
  getCurrentTab(): string {
    return this.currentTabSubject.getValue();
  }

  isSidebarOpen$ = this.isSidebarOpen.asObservable();
  // These are sharable data which we required on different componenets
  actions$ = this.actionsSource.asObservable();
  spotlights$ = this.spotlightsSource.asObservable();
  escalations$ = this.escalationsSource.asObservable();
  selectedLevel$ = this.selectedLevelSource.asObservable();
  options$ = this.optionsSource.asObservable();
  spotlightResponse$ = this.spotlightResponse.asObservable()



  openSidebar() {
    this.isSidebarOpen.next(true);
  }

  closeSidebar() {
    this.isSidebarOpen.next(false);
  }

  constructor(
    public _utilService: UtilsService,
  ) { }

  getFieldDefinitions(params: any) {//fied definations 
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.getFieldDefinitions);
      return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params));
    } catch (error) {
      console.error('An unexpected error occurred in getFieldDefinitions:', error);
      return throwError('An unexpected error occurred in getFieldDefinitions');
    }
  }


  huddleSpotlight(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.actionV1, environment.actionV1.HuddleSpotLight);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred while checking huddle:', error);
      // Add error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // We can customize the error message as needed
    }
  }
  getFeedListV3(params: any) {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.feedListV3);

    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }

  getAllHuddle(params: any) {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.huddleSummaryActive);
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }
  dataSetsValue(params: any) {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateCs, environment.webPrivateCs.datasetValuesList);
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }

  getBrandListDetails(params: any) {
    const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.brandsByIdList);
    return this._utilService.getAPICall(url, this._utilService.setHeaderWithParams(params))
  }
  getMeetingsList(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.actionV1, environment.actionV1.meetingsList);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaderWithParams({}))
    } catch (error) {
      console.error('An unexpected error occurred in huddlemeeting:', error);
      // Add error handling logic for unexpected errors here
      return throwError('An unexpected error occurred in huddlemeeting'); // We can customize the error message as needed
    }
  }

  huddleDownload(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.actionV1, environment.actionV1.Initiate_Huddle_Download);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaderWithParams({}))
    } catch (error) {
      console.error('An unexpected error occurred in huddleDownload:', error);
      // Add error handling logic for unexpected errors here
      return throwError('An unexpected error occurred in huddleDownload'); // We can customize the error message as needed
    }
  }
  huddleCreate(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.actionV1, environment.actionV1.huddleCreate);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaderWithParams({}))
    } catch (error) {
      console.error('An unexpected error occurred in huddlecreate:', error);
      // Add error handling logic for unexpected errors here
      return throwError('An unexpected error occurred in huddlecreate'); // We can customize the error message as needed
    }
  }

  huddleManagerList(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.actionV1, environment.actionV1.huddleManagersList);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaderWithParams({}))
    } catch (error) {
      console.error('An unexpected error occurred in huddlecreate:', error);
      // Add error handling logic for unexpected errors here
      return throwError('An unexpected error occurred in huddlecreate'); // We can customize the error message as needed
    }
  }
  huddleManagerListbyLevelandRole(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.actionV1, environment.actionV1.managersListbyLevelandRole);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaderWithParams({}))
    } catch (error) {
      console.error('An unexpected error occurred while checking huddle:', error);
      // Add error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // We can customize the error message as needed
    }
  }

  mergeEscalation(params) {
    try {
      const apiParam: any = {
        "brand_id": params.brandId,
        "app_id": params.appId,
        "feed_id_list": params.feedIdList,
        "hierarchy_level": params.hierarchyLevel,
        "hierarchy_value": params.hierarchyValue,
        "tags": params.tags
      }
      const url = this._utilService.apiUrlGeneration(environment.actionV1, environment.actionV1.escalationsCreate);
      return this._utilService.postAPICall(url, apiParam, this._utilService.setHeaderWithParams({}))
    } catch (error) {
      console.error('An unexpected error occurred while checking huddle:', error);
      // Add error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // We can customize the error message as needed
    }
  }

  setActions(actions: any) {
    this.actionsSource.next(actions);
  }


  setSpotlights(spotlights: any) {
    this.spotlightsSource.next(spotlights);
  }
  //This one is for response
  setSpotlightREsponse(spotlightResponse: any) {
    this.spotlightResponse.next(spotlightResponse)
  }
  setEscalations(escalations: any) {
    this.escalationsSource.next(escalations);
  }
  setSelectedLevel(level: string): void {
    this.selectedLevelSource.next(level);
  }
  setOptions(options: { [key: string]: string }): void {
    this.optionsSource.next(options);
  }

  updateManagerHuddleMergeAccess(accessDetail, brand) {
    // huddleEscalation.managerHasMergeAccess
    var accessLevel = _.get(accessDetail, "level");
    var managerHasMergeAccess;
    if (accessLevel) {
      var visibilityRule = _.get(brand, "action_management_configuration.huddle.rules.visibility.merge_escalation")
      if (visibilityRule && visibilityRule.value) {
        if (_.get(visibilityRule, "operator") == "in") {
          managerHasMergeAccess = (visibilityRule.value.indexOf(accessLevel) >= 0) ? true : false;
        } else if (_.get(visibilityRule, "operator") == "nin") {
          managerHasMergeAccess = !(visibilityRule.value.indexOf(accessLevel) >= 0) ? true : false;
        }

        return managerHasMergeAccess;
      }
    }
  }
}
